export default __webpack_public_path__ + "static/media/02.8c5b1b41.png";